import {
  ALL_MODULES_METADATA_ERROR,
  ALL_MODULES_METADATA_REQUEST,
  ALL_MODULES_METADATA_SUCCESS,
  ALL_MODULES_UPDATE_ORDER,
  MODULE_METADATA_ERROR,
  MODULE_METADATA_REQUEST,
  MODULE_METADATA_SUCCESS,
} from "./actionTypes";

import {
  ErrorFetchAllModulesMetadata,
  ErrorFetchModuleMetadata,
  RequestFetchAllModulesMetadata,
  RequestFetchModuleMetadata,
  SuccessFetchAllModulesMetadata,
  SuccessFetchModuleMetadata,
  ModuleMetadataDISPATCH,
  UpdateOrderOfModules,
} from "./types";

import { ModuleId } from "../../globalTypes";
import { AError } from "../../requests/types";

/* ********** FETCH ALL MODULES METADATA ********** */
export const requestFetchAllModulesMetadata =
  (): RequestFetchAllModulesMetadata => ({
    type: ALL_MODULES_METADATA_REQUEST,
  });

export const successFetchAllModulesMetadata = (
  allModulesMetadata: ModuleMetadataDISPATCH[]
): SuccessFetchAllModulesMetadata => ({
  type: ALL_MODULES_METADATA_SUCCESS,
  payload: allModulesMetadata,
});

export const errorFetchAllModulesMetadata = (
  error: AError
): ErrorFetchAllModulesMetadata => ({
  type: ALL_MODULES_METADATA_ERROR,
  error,
});

export const updateOrderOfAllModules = (
  modulesOrder: Record<number, number>
): UpdateOrderOfModules => ({
  type: ALL_MODULES_UPDATE_ORDER,
  payload: { modulesOrder },
});

/* ********** FETCH MODULE METADATA ********** */
export const requestFetchModuleMetadata = (
  moduleId: ModuleId
): RequestFetchModuleMetadata => ({
  type: MODULE_METADATA_REQUEST,
  payload: { id: moduleId },
});

export const successFetchModuleMetadata = (
  metadata: ModuleMetadataDISPATCH
): SuccessFetchModuleMetadata => ({
  type: MODULE_METADATA_SUCCESS,
  payload: metadata,
});

export const errorFetchModuleMetadata = (
  moduleId: ModuleId,
  error: AError
): ErrorFetchModuleMetadata => ({
  type: MODULE_METADATA_ERROR,
  payload: { id: moduleId },
  error,
});
